import React, {Component} from 'react'
import {jsonResponseHandler} from '../utils/FetchHelper'
import MenubarForm from "../components/design/MenubarForm"
import LoadingBox from "../components/common/LoadingBox";
import {connect} from "react-redux";
import LoadErrorBox from "../components/common/LoadErrorBox";
import * as InitStatus from '../constants/common/InitializationStatus';
import SubscriptionButtonForm from "../components/design/SubscriptionButtonForm";
import {addPrefix} from "../utils/UriUtil";

@connect(state => ({}),
    dispatch => ({
        dispatch
    }))
class DesignSettingApp extends Component {

    constructor(props) {
        super(props)
        this.state = {
            initialized : InitStatus.INIT_READY,
            optionList: []
        }
    }

    componentDidMount() {
        this.init();
    }

    init() {

        const {dispatch} = this.props;

        this.setState({
            initialized: InitStatus.INIT_DOING,
        });

        fetch(addPrefix("/manage/design/setting.json"), {
            credentials: 'include',
            headers: {'Content-Type': 'application/json'}
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                this.setState({
                    initialized: InitStatus.INIT_SUCCESS,
                    optionList: data.optionList,
                    selected: data.selected
                });
            })
            .catch(e => {
                console.error(e);
                this.setState({
                    initialized : InitStatus.INIT_FAIL,
                })
            });
    }

    render() {
        const {initialized, optionList, selected} = this.state;

        return <div className="inner_article decoration_article">
            <h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
            { (initialized === InitStatus.INIT_DOING ) && <LoadingBox />}
            { (initialized === InitStatus.INIT_FAIL ) && <LoadErrorBox retry={this.init}/>}
            { (initialized === InitStatus.INIT_SUCCESS ) &&
                <div className="blog_decoset">
					<h3 className="tit_cont">메뉴바 설정</h3>
					<MenubarForm optionList={optionList} selected={selected}/>
                    <h3 className="tit_cont">구독 버튼 설정</h3>
                    <SubscriptionButtonForm optionList={optionList} selected={selected}/>
				</div>
			}
        </div>

    }
}

export default DesignSettingApp
